import React from "react";
import PodcastDeviceTemplate from "themes/administration/user/components/PodcastDeviceTemplate";

function PodcastDevice(props) {
    return <PodcastDeviceTemplate {...props} />;
}

export default PodcastDevice;
